import { useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";
import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

type Props = {
	type: CalculatorType;
	bgColor?: string;
	disableBottomBarSpacing?: boolean;
};

export const CalculatorPageLayout: FC<PropsWithChildren<Props>> = ({
	type,
	bgColor,
	disableBottomBarSpacing,
	children,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<MyPlannLayout
			disableContentPadding
			disableBottomBarSpacing={disableBottomBarSpacing}
			bgColor={bgColor ?? theme.palette.surface.muted}
			topBar={
				<NavigationHeader
					title={t(Resources.Calculators.Names[type])}
					bgColor={theme.palette.background.paper}
					defaultRoute={Routing.Calculators.CalculatorList.path()}
				/>
			}
		>
			{children}
		</MyPlannLayout>
	);
};
